//  ENV variables
export const NODE_ENV = process.env.NODE_ENV || 'development';
export const APP_NAME = process.env.REACT_APP_NAME || 'development';
export const API_URL = process.env.API_URL || 'http://foleja-middleware.com/api/';
export const AUTH_TOKEN_KEY = process.env.AUTH_TOKEN_KEY || 'foleja-token';

export const SPACE_BASE_URL =
  process.env.SPACE_BASE_URL || 'https://foleja.fra1.cdn.digitaloceanspaces.com/static';
